<template>
	<div class="wrapper-loading">
		<div v-if="!showText" class="loading"/>
		<div v-else class="loading-text">
			{{ title }}
			<h2>{{ $locale.baseText('loading.organization') }}</h2>
		</div>
	</div>
</template>

<script>
import { setupHeaderAliareTenant } from '@/config/axiosConfig';
import { PLACEHOLDER_EMPTY_WORKFLOW_ID } from '@/constants';
import { createNewAccount } from '@/components/helpers';
import WebStorage from '@/common/WebStorage';

export default {
	name: 'ChangeLoading',
	data() {
		return {
			title: '',
			showText: false,
		};
	},
	created() {
		this.handleOrganization();
	},
	methods: {
		handleOrganization() {
			const loadingData = this.$store.getters?.loadingData;
			this.$store.commit('setWorkspace', loadingData.workspace);
			WebStorage.setItem('workspace', JSON.stringify(loadingData.workspace));

			if (loadingData?.route === 'duplicateProject') {
				this.handleDuplicate('project/projectdetailing/', loadingData.id);

			} else if (loadingData?.route === 'duplicateWorkflow') {
				this.handleDuplicate('workflow/', loadingData.id);

			} else if(loadingData?.route === 'accessWorkspace') {
				this.$router.push({	name: 'project',});
			}
		},

		async handleDuplicate(basePath, id, query = '') {
			const data = this.$store.getters.loadingData;

			if(data.multi){
				const tenantId = data?.account?.id;

				WebStorage.setItem('tenantId', tenantId);
				const account = await createNewAccount(data?.account);
				const response = await this.getAccountDataV2(data?.account.tenantId);

				accountInfo = {
					...accountInfo,
					principalAdminUser: response.principalAdminUser,
					adminUsers: response.adminUsers,
				}

				WebStorage.setItem('accountInfo', JSON.stringify(account));
				setupHeaderAliareTenant(tenantId);
			}
			this.$root.$emit("reloadHeader");

			setTimeout(() => {
				this.$router.push(`/${basePath}${id}${query}`);
			}, 3000);
		},
	},
	beforeDestroy() {
		this.$store.commit('setLoadingData', PLACEHOLDER_EMPTY_WORKFLOW_ID);
	},
};
</script>

<style scoped>
h2 {
	font-family: 'Roboto', sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	text-align: center;
	color: #FFFFFFE0;
	margin-top: 20px;
}

.wrapper-loading {
	display: flex;
	background-image: url('../assets/backgroud.svg');
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	justify-content: center;
	text-align: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
  position: absolute;
  z-index: 99;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
}

.loading {
	background-image: url('../assets/loading.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 100%;
  height: 20%;
  position: absolute;

	-webkit-animation: fadein 7s ease-in infinite;
	-moz-animation: fadein 7s ease-in infinite;
	animation: fadein 7s ease-in infinite;
}

.loading-text {
  position: absolute;
  width: 100%;
  height: 30%;
	color: #FFFFFF;
  font-size: 56px;
	font-weight: 300;
	line-height: 66px;
	text-align: center;
}
</style>
